var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.inst_data!=null)?_c('employee-profile-tab',{attrs:{"instid":_vm.inst_data.instid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }